import { useState } from "react";
import styles from "../../styles/addReceipt.module.css";
import { InvoiceCxc } from "./InvoiceCxc";
import { CxcSummary } from "./CxcSummary";
import { formatCurrency } from "../../../../../shared/utils/formatCurrency";

const PAGE_SIZE = 10;

export function CxcDetails({
  setFacturasData,
  facturasData,
  updateAbono,
  updateChecked,
  restante,
  count,
  onDistribute,
  receiptMonto,
}) {
  console.log(facturasData)
  return (
    <div className={styles["cxc-details"]}>
      <CxcDetailsHeader />
      <CxcDetailsBody
        setFacturasData={setFacturasData}
        facturasData={facturasData}
        count={count}
        updateAbono={updateAbono}
        updateChecked={updateChecked}
        onDistribute={onDistribute}
        receiptMonto={receiptMonto}
      >
        <CxcSummary
          handleCurrencyFormat={formatCurrency}
          facturasData={facturasData}
          restante={restante}
        />
      </CxcDetailsBody>
    </div>
  );
}

function CxcDetailsHeader() {
  return (
    <div className={styles["cxc-details-header"]}>
      <h1>
        <i className={`fa-solid fa-folder ${styles["icon-cxc-details"]}`} />{" "}
        Registro Cuentas por Cobrar
      </h1>
    </div>
  );
}

function CxcDetailsBody({
  setFacturasData,
  facturasData,
  count,
  updateAbono,
  updateChecked,
  onDistribute,
  receiptMonto,
  children,
}) {
  const [page, setPage] = useState(1);
  const totalPages = Math.ceil(facturasData.length / PAGE_SIZE);

  const visibles = facturasData.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE);

  function handleSelectAll(checked) {
    if (checked) {
      onDistribute();
    } else {
      setFacturasData((prev) =>
        prev.map((inv) => ({ ...inv, abono: 0, favor: 0, checked: false })),
      );
    }
    setPage(1);
  }

  // Boolean explícito: evita que React reciba un objeto truthy como checked
  const someChecked = Boolean(facturasData.find((inv) => inv.checked));
  const remainingMonto =
    receiptMonto -
    facturasData.reduce((acc, f) => acc + (Number(f.abono) || 0), 0);

  return (
    <div className={styles["receipt-details-body"]}>
      <div className={styles["table-responsive"]}>
        <div className={styles["invoice-table"]}>
          <table>
            <thead>
              <tr>
                <th>
                  <input
                    type="checkbox"
                    checked={someChecked}
                    onChange={(e) => handleSelectAll(e.target.checked)}
                  />
                </th>
                <th>Factura</th>
                <th>Rubro</th>
                <th>Saldo</th>
                <th style={{ paddingRight: "20px" }}>Abono</th>
              </tr>
            </thead>
            <tbody>
              {visibles.map((inv) => (
                <InvoiceCxc
                  key={inv.id}
                  inv={inv}
                  updateAbono={updateAbono}
                  updateChecked={updateChecked}
                  remainingMonto={remainingMonto}
                />
              ))}
            </tbody>
          </table>

          <div
            className={styles["footer-info"]}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "8px 14px",
              minWidth: 720,
            }}
          >
            <span>{facturasData.length} CxC activa(s)</span>

            {totalPages > 1 && (
              <div style={{ display: "flex", gap: 6, alignItems: "center" }}>
                <button
                  disabled={page === 1}
                  onClick={() => setPage((p) => p - 1)}
                  style={{
                    padding: "3px 10px",
                    fontSize: 12,
                    background:
                      page === 1 ? "rgba(55,65,81,0.2)" : "rgba(55,65,81,0.5)",
                    color: page === 1 ? "#4b5563" : "#9ca3af",
                    border: "1px solid #364250",
                    borderRadius: 4,
                    cursor: page === 1 ? "not-allowed" : "pointer",
                  }}
                >
                  ‹ Ant
                </button>
                <span style={{ fontSize: 12, color: "#9ca3af" }}>
                  {page} / {totalPages}
                </span>
                <button
                  disabled={page === totalPages}
                  onClick={() => setPage((p) => p + 1)}
                  style={{
                    padding: "3px 10px",
                    fontSize: 12,
                    background:
                      page === totalPages
                        ? "rgba(55,65,81,0.2)"
                        : "rgba(55,65,81,0.5)",
                    color: page === totalPages ? "#4b5563" : "#9ca3af",
                    border: "1px solid #364250",
                    borderRadius: 4,
                    cursor: page === totalPages ? "not-allowed" : "pointer",
                  }}
                >
                  Sig ›
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
      {children}
    </div>
  );
}
